import { IDeleteGestaoEpiUseCase } from "../../../presentation/useCases/delete/delete_gestao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * DeleteGestaoEpiUseCase
 */

export class DeleteGestaoEpiUseCase implements IDeleteGestaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async deleteGestaoEpi(
    idGestaoEpi: number,
  ): Promise<void> {
    await this.repository.deleteGestaoEpi(idGestaoEpi);
  }
}
